<template>
  <div v-if="fieldLoader" class="el-input el-input--large el-input__inner">{{ loadingText }}</div>
  <base-input
    v-else-if="computedReadOnly"
    :value="content"
    :data-id="`${fieldNameProp}-${name}-datalist`"
    :name="name"
    :read-only="true"
  />
  <el-select
    v-else
    v-model="value"
    ref="infinite-dropdown"
    :id="singleSelectId"
    :data-id="`${fieldNameProp}-${name}-datalist`"
    :class="[{ invalid: isInvalid }, 'stretch']"
    :name="name"
    :clearable="clearable"
    :no-data-text="noDataText"
    :no-match-text="noDataText"
    :placeholder="placeholder"
    :size="size"
    filterable
    remote
    :remote-method="filterOptions"
    @hook:mounted="cancelReadOnly"
    @visible-change="onVisibleChange"
    @clear="onClear"
  >
    <el-option
      v-for="{ key, value } in filteredOptions"
      :key="key"
      :label="value"
      :value="key"
      :data-id="`${name}-option--${key}`"
    />
    <loader class="h-25" v-if="optionLoader" />
  </el-select>
</template>

<script>
import { get } from 'lodash'
import dropdownMixin from '../../../utils/mixin-dropdown'
import BaseInput from './BaseInput.vue'
import Loader from '../../Loader.vue'

export default {
  name: 'SingleSelect',
  components: {
    BaseInput,
    Loader,
  },
  mixins: [dropdownMixin],
  data() {
    return {
      singleSelectQuery: '',
      size: 'large',
      isSingleSelect: true,
    }
  },
  computed: {
    /**
     * @description Readonly eseten ez a tartalom jelenik meg
     * @returns {string}
     */
    content() {
      if (this.dropdownHasValue && Array.isArray(this.options)) {
        return get(
          this.options.find((elem) => String(elem.key) === String(this.value)),
          'value',
          '',
        )
      }
      return ''
    },
  },
}
</script>
